<template>
  <div class="price-filter">
        <div @click="collapse" class="title-container">
            <p class="title">Price</p>
            <p class="icon">{{plusIcon}}</p>
        </div>
        <div v-if="!collapsed" class="price-slide-container">
        <div class="price-container">
            <span>Min: ${{rangePrice.min}}</span>
            <span>Max: ${{rangePrice.max}}</span>
        </div>
        <MultiRangeSlider
            :baseClassName="'range-slider'"
            :min="prices.min"
            :max="prices.max"
            :step="1"
            :ruler="false"
            :label="false"
            :minValue="rangePrice.min"
            :maxValue="rangePrice.max"
            @input="UpdateValues"
        />
        </div>
  </div>
</template>

<script>
import smoothReflow from 'vue-smooth-reflow'
import MultiRangeSlider from "multi-range-slider-vue";

export default {
    mixins: [smoothReflow],
    components: {
        MultiRangeSlider
    },
    props:{
        prices: Object
    },
    watch:{
        prices:{ 
            handler(newVal){
                this.rangePrice = { min:newVal.min, max:newVal.max };
                this.pricesChanged = true;
            },
            deep: true
        }
    },
    data() {
        return{
            collapsed: true,
            pricesChanged: false,
        }
    },
    computed: {
        rangePrice: {
            get(){return this.$store.state.rangePriceMobile},
            set(value){this.$store.commit('setRangePriceMobile', value )}
        },
        plusIcon(){
            return this.collapsed == true ? '+' : '-';
        },
    },
    methods: {
        collapse(){
            this.collapsed = !this.collapsed;
        },
        UpdateValues(e) {
            if(this.pricesChanged){
                this.pricesChanged = false;
                return;
            }
            this.rangePrice = {min:e.minValue, max:e.maxValue};
        }
    },
    mounted(){
        this.$smoothReflow();
        this.rangePrice = {min:this.prices.min,max:this.prices.max};
    },
}
</script>

<style lang="scss" scoped>
.price-filter{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: white;
    box-shadow: inset 0px -1px 0px #E6E8EC;
}

.icon{
    cursor: pointer;
    font-size: 1rem;
    margin: unset;
}

.title-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding: 2% 5%;
}
.title{
    color: #0F0C38;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 700;
    font-size: 1.3vw;
    line-height: 1.5;
    margin: unset;
}

.price-slide-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0% 0% 3% 5%;
    width: 100%;
    overflow: hidden;
}

.price-container{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.price-container span{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1.2vw;
    line-height: 1.3;
    align-items: center;
    justify-content: space-between;
}

@media screen and (max-width: 767px){
    .title{
        font-size: 1.2rem;
    }

    .icon{
        font-size: 2rem;
    }
    .price-container span{
        font-size: 1rem;
    }
}
</style>
<style>
.range-slider{
    width: 100%;
    display: flex;
    position: relative;
    border: none;
    border-radius: 0;
    padding: 10px;
    box-shadow: none;
    flex-direction: column;
    user-select: none;
}

.range-slider *{
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}

.range-slider .input-type-range {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    opacity: 0;
    pointer-events: none;
}

.range-slider .bar{
    display: flex;
}

.range-slider .bar-left{
    width: 25%;
    background-color: #F3F4F6;
    border-radius: 10px 0 0 10px;
    padding: 4px 0;
}

.range-slider .bar-inner{
    background-color: #0F0C38;
    display: flex;
    flex-grow: 1;
    flex-shrink: 1;
    position: relative;
    justify-content: space-between;
}

.range-slider .bar-inner-left, .range-slider .bar-inner-right {
    width: 50%;
}

.range-slider .bar-right {
    width: 25%;
    background-color: #F3F4F6;
    border-radius: 0 10px 10px 0;
}

.range-slider .thumb:before{
    content: "";
    background-color: #fff;
    position: absolute;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    z-index: 1;
    margin: -5px;
    cursor: pointer;
    box-shadow: 0px 2px 4px #1f29370f, 0px 4px 6px #1f29371a;
}

.range-slider .caption{
    display: none;
}
</style>